<template>
  <ul class="life">
    <li class="life-item" v-for="life in lifes"></li>
    <ul class="life life-mask">
      <li class="life-item disabled"></li>
      <li class="life-item disabled"></li>
      <li class="life-item disabled"></li>
    </ul>
  </ul>
</template>

<script>
export default {
  name: "lifeStatus",
  props:[
      'lifes'
  ]
}
</script>
